import { combineReducers } from '@reduxjs/toolkit';

import ui from './ui';
import data from './data';

/**
 * @typedef {{
 *  data: import('./data').DataState,
 *  ui: import('./ui').UIState,
 * }} ChatReducersState
 */

export default combineReducers({
  data,
  ui,
});
